export const SET_USERS_FILTERS = 'SET_USERS_FILTERS';

export const setUsersFilters = ({ text = '', profile = '', enabled = '', company = '' } = {}) => ({
    type: SET_USERS_FILTERS,
    payload: {
        text,
        profile,
        enabled,
        company
    }
});
